import {Component, Inject, OnInit} from '@angular/core';
import {MsgBoxService} from '../../shared/msg-box.service';
import {UserProfile} from 'auth-commons';
import {LoginService} from '../../shared/login.service';
import {I18NService} from '../../i18n/i18n.service';
import {HttpErrorResponse} from '@angular/common/http';
import {APP_CONFIG_TOKEN, AppConfig} from '../../app.config';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    constructor(@Inject(APP_CONFIG_TOKEN) private readonly cfg: AppConfig,
                private readonly i18n: I18NService,
                private readonly loginService: LoginService,
                private readonly msgBoxService: MsgBoxService) {
    }

    ngOnInit() {
    }

    onLogin(user: UserProfile) {
        this.loginService.notifyLogin(user);
    }

    onErrorOccurred(event: [string, Error]) {
        const msg = mkErrorMessage(event[1]) || event[0];
        this.msgBoxService.error(this.i18n.translate(msg), event[1]);
    }
}

function mkErrorMessage(err: Error): string {
    if (err instanceof HttpErrorResponse && err.status === 401) {
        return 'Invalid credentials';
    }
    return 'An error occurred while logging in user';
}
